import products from "./products.json";

export const siteUrl = "https://pt-bas.com";

export const categories = [
  {
    slug: "coronary",
    path: "/category/coronary",
    title: "Coronary",
    description:
      "Coronary intervention products for cath lab workflows, including stents, balloons, CTO devices, and supporting product documentation.",
    imageUrl: "/assets/ximus.jpg",
    seo: {
      title: "Coronary Products | PT BAS",
      description:
        "Explore PT BAS coronary products for cath lab procurement, including DES, DEB, PTCA balloons, CTO balloons, brochures, and product detail links.",
    },
  },
  {
    slug: "peripheral",
    path: "/category/peripheral",
    title: "Peripheral",
    description:
      "Peripheral balloon products for vascular and hemodialysis access workflows, with brochures and product details for procurement teams.",
    imageUrl: "/assets/legflow.png",
    seo: {
      title: "Peripheral Products | PT BAS",
      description:
        "Explore PT BAS peripheral product information, including LEGFLOW and APERTO product pages with brochures, specifications, and quotation CTAs.",
    },
  },
  {
    slug: "accessories",
    path: "/category/accessories",
    title: "Accessories",
    description:
      "Cath lab accessories including guiding and angiographic catheter products for interventional and diagnostic workflows.",
    imageUrl: "/assets/Primum.png",
    seo: {
      title: "Accessories Products | PT BAS",
      description:
        "Explore PT BAS cath lab accessories including PRIMUM and POINTER product details, brochures, specifications, and contact sales links.",
    },
  },
];

export const seoDefaults = {
  home: {
    title: "PT BAS | Distributor Alat Kesehatan Cath Lab Indonesia",
    description:
      "PT Bintang Anugerah Sukses is a medical equipment distributor focused on cath lab supply, product availability, and hospital support in Indonesia.",
    path: "/",
  },
  about: {
    title: "About PT BAS | Medical Equipment Distributor Since 2015",
    description:
      "Learn about PT Bintang Anugerah Sukses, a medical equipment distribution company established in 2015 and focused on cath lab product support.",
    path: "/about",
  },
  contact: {
    title: "Contact PT BAS | Medical Equipment Sales & Support",
    description:
      "Contact PT BAS for medical equipment quotation, product documentation, availability, and cath lab sales support in Indonesia.",
    path: "/contact",
  },
  news: {
    title: "News & Events | PT BAS",
    description:
      "Read PT BAS news, healthcare distribution updates, company activities, and selected medical equipment event information.",
    path: "/news",
  },
  category: {
    title: "Medical Device Product Categories | PT BAS",
    description:
      "Browse PT BAS medical device product categories for coronary, peripheral, and cath lab accessories with links to product detail pages.",
    path: "/category",
  },
};

export const contactDetails = {
  address:
    "Ruko Ubud Village Blok Kuta A No.25 Ciledug, Tangerang, Banten, Indonesia",
  phone: "+62 7306932",
  fax: "+62 7306928",
  email: "Sales@pt-bas.com",
  secondaryEmail: "Bintang.Anugerah.Sukses@gmail.com",
};

export const productsCatalog = products;

export const getProductsByCategory = (categorySlug) =>
  productsCatalog.filter((product) => product.categorySlug === categorySlug);

export const getProductById = (id) =>
  productsCatalog.find((product) => product.id === id);

export const getProductByPath = (path) =>
  productsCatalog.find((product) => product.path === path);

export const getCategoryBySlug = (slug) =>
  categories.find((category) => category.slug === slug);

export const getRelatedProducts = (product, limit = 4) => {
  const explicitRelated = (product.relatedProductIds || [])
    .map(getProductById)
    .filter(Boolean);
  const sameCategory = productsCatalog.filter(
    (item) => item.categorySlug === product.categorySlug && item.id !== product.id
  );
  const related = [...explicitRelated, ...sameCategory].filter(
    (item, index, list) => list.findIndex((entry) => entry.id === item.id) === index
  );

  return related.slice(0, limit);
};
